import React from 'react';
import styled from 'styled-components';
import {TscThemeName, TscThemeNames, TscStyles} from '@techsmith/tsc-cloud-style-guide';

const Container = styled.div<{theme: TscThemeNames; breakpoint: string}>`
   background: ${props => props.theme === TscThemeName.dusk ? TscStyles.color.ui.dusk.mediumDark : TscStyles.color.ui.dawn.lightMedium};
   border: 1px solid ${props => props.theme === TscThemeName.dusk ? TscStyles.color.ui.dusk.dark : TscStyles.color.ui.dawn.medium};
   border-radius: ${TscStyles.border.radius.lg};
   padding: 1rem;
   margin: 1rem 0 0 1rem;

   @media screen and (max-width: ${props => props.breakpoint}) {
      background: none;
      border-top: 1px solid ${props => props.theme === TscThemeName.dusk ? TscStyles.color.ui.dusk.dark : TscStyles.color.ui.dawn.medium};
      border-left: none;
      border-right: none;
      border-bottom: none;
      padding-left: 0;
      padding-right: 0;
      padding-bottom: 0;
      margin: 0;
      border-radius: 0;
   }

   input {
      outline-offset: 0;
   }
`;

const Header = styled.h3`
   font-weight: 600;
   margin: 0 0 1rem 0;
   font-size: 1rem;
`;

const SideMenu: React.FC<ISideMenu> = ({children, headerText, theme, breakpoint}) => (
   <Container theme={theme} breakpoint={breakpoint}>
      <Header>
         {headerText}
      </Header>
      {children}
   </Container>
);

export interface ISideMenu {
   children?: React.ReactNode;
   headerText: string;
   theme: TscThemeNames;
   breakpoint: string;
}

export default SideMenu;
